module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper"
  }, [(_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), (_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "breadcrumbsData": _vm.breadcrumbData
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("Transfer request")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom-margin"
  }, [_c('div', {
    staticClass: "modal-body mt-lg"
  }, [(!_vm.transferNote.transactionId) ? _c('form', {
    staticClass: "mb-xl top-margin form-row",
    attrs: {
      "role": "form",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-group has-feedback searchbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.text),
      expression: "search.text"
    }],
    staticClass: "form-control",
    attrs: {
      "autofocus": "",
      "id": "searchText",
      "type": "text",
      "placeholder": "Search account number",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.search.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search.text = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.searchAccount()
      }
    }
  }, [_c('em', {
    staticClass: "icon-magnifier pr-sm"
  }), _vm._v(" Search\n                  ")])])]) : _vm._e(), _vm._v(" "), (!_vm.search.account && _vm.search.hasSearched) ? _c('div', {
    staticClass: "panel-body"
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.search.account || _vm.selectedAccount) ? _c('div', {
    staticClass: "top-margin"
  }, [_c('table', {
    staticClass: "table table-striped bank-accounts table-fundings"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [(_vm.selectedAccount) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.selectedAccount.accountId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.selectedAccount.accountName))]), _vm._v(" "), _vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.search.account && (!_vm.selectedAccount || _vm.search.account.id !== _vm.selectedAccount.id)) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.search.account.accountId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.search.account.accountName))]), _vm._v(" "), _c('td', [(!_vm.selectedAccount || _vm.search.account.id !== _vm.selectedAccount.id) ? _c('button', {
    staticClass: "btn btn-details btn-outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.selectAccount(_vm.search.account)
      }
    }
  }, [_vm._v("Select account")]) : _c('span', {
    staticClass: "action-span green-text"
  }, [_c('i', {
    staticClass: "fa fa-check check"
  }), _vm._v("Selected\n                        ")])])]) : _vm._e()])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_vm._v("Please append your comment below *")]), _vm._v(" "), _c('restricted-textarea', {
    attrs: {
      "input": _vm.comment,
      "limit": 255,
      "id": "comment",
      "placeholder": "",
      "required": true
    },
    on: {
      "inputUpdated": _vm.commentUpdated
    }
  }), _vm._v(" "), (!_vm.comment || _vm.transaction.comment === _vm.comment) ? _c('p', {
    staticClass: "top-margin",
    staticStyle: {
      "color": "red"
    }
  }, [_c('i', [_vm._v("You must enter or append a comment.")])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg button-white buttons",
    attrs: {
      "type": "submit",
      "disabled": !!_vm.transferNote.transactionId && _vm.isCancelButtonDisabled()
    },
    on: {
      "click": function($event) {
        !_vm.transferNote.transactionId ? _vm.goToNoteDetail() : _vm.showTransferConfirmationModal()
      }
    }
  }, [_vm._v("Cancel request")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg button-white buttons",
    attrs: {
      "type": "submit",
      "disabled": !_vm.transferNote.transactionId || _vm.isButtonDisabled()
    },
    on: {
      "click": _vm.approveTransfer
    }
  }, [_vm._v("Approve transfer")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg button-approve buttons",
    attrs: {
      "type": "submit",
      "disabled": !!_vm.transferNote.transactionId || _vm.isButtonDisabled()
    },
    on: {
      "click": _vm.submitRequest
    }
  }, [_vm._v("Submit request")])])])])])])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      All users\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info alert-dismissible mt-lg not-found-alert",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', [_c('em', {
    staticClass: "icon-info pr-sm"
  }), _vm._v("No results found.\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Account number")]), _vm._v(" "), _c('th', [_vm._v("Account name")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    staticClass: "action-span green-text"
  }, [_c('i', {
    staticClass: "fa fa-check check"
  }), _vm._v("Selected\n                        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27e77d4d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Transfer.vue
// module id = 2126
// module chunks = 1